import { render, staticRenderFns } from "./breakfastReport.vue?vue&type=template&id=883aca78"
import script from "./breakfastReport.vue?vue&type=script&lang=js"
export * from "./breakfastReport.vue?vue&type=script&lang=js"
import style0 from "./breakfastReport.vue?vue&type=style&index=0&id=883aca78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports